import styled from 'styled-components';
import InputGroup from 'react-bootstrap/lib/InputGroup';

const InputGroupText = styled(InputGroup.Addon)`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1em;
    font-weight: bold;
    width: auto;
    height: 45px;
    border: 1px solid ${props => props.theme.colors.darkgray};
`;

export default InputGroupText;



// WEBPACK FOOTER //
// ./src/components/atoms/form/InputGroupText.js